import { Link } from "react-router-dom"
import Moment from 'react-moment'
import 'moment/locale/ru'
import { useEffect, useRef } from "react"

export default function Card({ event, height, setHeight }) {
    const front = useRef()
    const back = useRef()

    const resize = () => {
        if (front.current && back.current) {
            setHeight((prev) => {
                let h = prev
                if (front.current.clientHeight > h)
                    h = front.current.clientHeight
                if (back.current.clientHeight > h)
                    h = back.current.clientHeight
                return h
            })
        }
    }

    useEffect(resize, [front, back])

    return (
        <Link to={`/showroom/event/${event._id}`} className="program-block">
            <div className="program-flipper" style={{ height: `${height}px` }}>
                <div className="program-front" ref={front}>
                    <div className="program-header">
                        <h3>{event.label}</h3>
                        {event.date &&
                            <p><Moment date={event.date} format="DD MMMM YYYY" locale="ru" /></p>
                        }
                    </div>
                    <img onLoad={resize} src={event.image.src} alt="program-image" className="program-image" />
                </div>
                <div className="program-back" ref={back}>
                    <h3>{event.label}</h3>
                    {event.date &&
                        <p><Moment date={event.date} format="DD MMMM YYYY" locale="ru" /></p>
                    }
                    <div className="program-back__row">
                        {event.program.slice(0, 4).map(item => (
                            <div className="program-back__block" key={item.time}>
                                <div className="program-back__time">{item.time}</div>
                                <div className="program-back__text">{item.text}</div>
                            </div>
                        ))}
                    </div>
                    <Link to={`/showroom/event/${event._id}`} className="program-back__program">
                        Подробнее о программе
                    </Link>
                    <Link to={`/showroom/event/${event._id}?reg=true`} className="program-back__regist">
                        зарегистрироваться
                    </Link>
                </div>
            </div>
        </Link>
    )
}